import styled from 'styled-components';

import SUIControlGroup from '@splunk/react-ui/ControlGroup';
import { variables } from '@splunk/themes';

export const ControlGroup = styled(SUIControlGroup)`
    margin-top: 0;
    padding: 0;
    margin-bottom: ${variables.spacingLarge};
    width: 100%;

    &:last-child {
        margin-bottom: 0;
    }

    [data-test='label']:first-of-type {
        padding-top: 0;
    }
`;
